/* RIXOKIN theme: upgrade layer interactions (loads after rixokin.js). No dependencies. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function restart(el, cls) { el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); }

  function init(root) {
    /* Hero video: pause button, reduced motion, pause when off screen */
    $$('[data-rx-hero-video]', root).forEach(function (v) {
      if (v.__rx) return; v.__rx = true;
      v.muted = true; v.playsInline = true;
      var btn = v.parentNode.querySelector('[data-rx-hero-pause]');
      var userPaused = reduce;
      function set(paused) {
        userPaused = paused;
        if (paused) v.pause(); else { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        if (btn) { btn.setAttribute('aria-pressed', paused ? 'true' : 'false'); btn.setAttribute('aria-label', paused ? 'Play background video' : 'Pause background video'); }
      }
      if (btn) btn.addEventListener('click', function () { set(!userPaused); });
      set(userPaused);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (userPaused) return; if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); });
        }, { threshold: 0.15 }).observe(v);
      }
    });

    /* Value badges: tilt toward the pointer, stamp on tap */
    $$('[data-rx-badge]', root).forEach(function (b) {
      if (b.__rx) return; b.__rx = true;
      if (!reduce) {
        b.addEventListener('pointermove', function (e) {
          if (e.pointerType !== 'mouse') return;
          var r = b.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
          b.style.setProperty('--rx-ty', (x * 26).toFixed(1) + 'deg');
          b.style.setProperty('--rx-tx', (-y * 26).toFixed(1) + 'deg');
        });
        b.addEventListener('pointerleave', function () { b.style.removeProperty('--rx-ty'); b.style.removeProperty('--rx-tx'); });
      }
      b.addEventListener('click', function () { if (!reduce) restart(b, 'is-stamp'); });
    });

    /* Problem cards: flip to the RIXOKIN answer */
    $$('.rx-flip', root).forEach(function (card) {
      if (card.__rx) return; card.__rx = true;
      var front = card.querySelector('.rx-flip__front'), back = card.querySelector('.rx-flip__back');
      if (!back) return;
      function sync(open) {
        card.classList.toggle('is-flipped', open);
        back.setAttribute('aria-hidden', open ? 'false' : 'true'); front.setAttribute('aria-hidden', open ? 'true' : 'false');
        if ('inert' in back) { back.inert = !open; front.inert = open; }
        $$('[data-rx-flip]', card).forEach(function (btn) { btn.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      }
      sync(false);
      $$('[data-rx-flip]', card).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var open = !card.classList.contains('is-flipped');
          sync(open);
          var next = (open ? back : front).querySelector('[data-rx-flip]');
          if (next) setTimeout(function () { next.focus({ preventScroll: true }); }, reduce ? 0 : 380);
        });
      });
    });

    /* Printed Amounts: draw the level line and print the body on tap */
    $$('[data-rx-level]', root).forEach(function (m) {
      if (m.__rx) return; m.__rx = true;
      var sec = m.closest('section'), body = sec && sec.querySelector('[data-rx-print]');
      m.addEventListener('click', function () {
        m.classList.toggle('is-level');
        if (body && !reduce && m.classList.contains('is-level')) restart(body, 'is-print');
      });
    });

    /* Smart Spoon: each tap sends a ring and lights the next step */
    $$('[data-rx-spoon-tap]', root).forEach(function (t) {
      if (t.__rx) return; t.__rx = true;
      var sec = t.closest('section'), steps = sec ? $$('[data-rx-step]', sec) : [], i = -1;
      var nfc = sec ? sec.querySelector('[data-rx-nfc]') : null;
      t.addEventListener('click', function () {
        if (!reduce) { restart(t, 'is-burst'); if (nfc) restart(nfc, 'is-burst'); }
        if (!steps.length) return;
        i = (i + 1) % steps.length;
        steps.forEach(function (s, k) { s.classList.toggle('is-active', k === i); if (k === i) s.setAttribute('aria-current', 'step'); else s.removeAttribute('aria-current'); });
      });
    });
  }

  /* Problem and why powder: a card matched to a table column highlights it */
  function initVersus(root) {
    $$('[data-rx-versus]', root).forEach(function (sec) {
      if (sec.__rxv) return; sec.__rxv = true;
      var cards = $$('[data-rx-match]', sec);
      function pinned() { var c = sec.querySelector('[data-rx-match].is-flipped'); return c ? c.getAttribute('data-rx-match') : ''; }
      function set(key) { if (key) sec.setAttribute('data-focus', key); else sec.removeAttribute('data-focus'); }
      cards.forEach(function (c) {
        var key = c.getAttribute('data-rx-match');
        c.addEventListener('mouseenter', function () { set(key); });
        c.addEventListener('focusin', function () { set(key); });
        c.addEventListener('mouseleave', function () { set(pinned()); });
        c.addEventListener('focusout', function () { setTimeout(function () { if (!c.contains(document.activeElement)) set(pinned()); }, 0); });
        c.addEventListener('click', function () { setTimeout(function () { set(c.classList.contains('is-flipped') ? key : pinned()); }, 0); });
      });
    });
  }

  /* Header: shadow once the page scrolls */
  var header = document.querySelector('.rx-header');
  if (header) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () { header.classList.toggle('is-scrolled', window.scrollY > 8); ticking = false; });
    }, { passive: true });
  }

  function all(r) { init(r); initVersus(r); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(document); });
  else all(document);
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
})();
